module.exports = __webpack_public_path__ + "img/한식.a1b610e3.png";